import { FC } from 'react'

import { useDispatch } from 'react-redux'
import styled from 'styled-components'
import { useNavigate } from 'react-router-dom'

import User from 'src/Assets/user.svg'
import { colors } from 'src/Helpers/constants.ts'
import { Image } from 'src/Components/Image'
import LogOut from 'src/Assets/logout.svg?react'
import { clearCredentials } from 'src/Redux/auth-process/authSlice.ts'
import { RoutesEnum } from 'src/Router/types.ts'

import { IconButton } from '../Button/IconButton'

const Container = styled.div<{
  $isCollapsed?: boolean
}>`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 15px;
  padding: 17px;
  border-radius: 15px;
  width: ${({ $isCollapsed }) => ($isCollapsed ? '90px' : '300px')};
  border: 3px solid ${colors.fourthBlue};
`

const Name = styled.span`
  font-size: 14px;
  max-width: 200px;
  width: 100%;
  text-align: left;
  color: ${colors.thirdGray};
  font-weight: 600;
`

const StyledImage = styled(Image)`
  display: flex;
  width: 30px;
  height: 30px;
  align-items: center;
`

const StyledButton = styled(IconButton)`
  svg {
    path {
      fill: ${colors.fourthBlue};
    }
  }
  border-radius: 20px;
`
interface UserInfoProps {
  imageUrl?: string
  name: string
  className?: string
}

export const UserInfo: FC<UserInfoProps> = ({ imageUrl, name, className }) => {
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const handleLogout = (): void => {
    dispatch(clearCredentials())
    navigate(RoutesEnum.ROOT)
  }

  if (!name) {
    return null
  }
  return (
    <Container className={className}>
      <StyledImage src={imageUrl} fallbackSrc={User} />
      <Name>{name}</Name>
      <StyledButton
        onClick={handleLogout}
        tooltiptext={'Выход'}
        data-testid={'logout'}
      >
        <LogOut width={30} height={30} />
      </StyledButton>
    </Container>
  )
}
